import { createLucideIcon } from 'lucide-react';
export const EyeIcon = createLucideIcon('eye', [
  [
    'path',
    {
      d: 'M12 7C14.8795 7 17.2138 9.2386 17.2138 12C17.2138 14.7614 14.8795 17 12 17',
      key: '1hxeuw',
    },
  ],
  [
    'path',
    {
      d: 'M12 7C17.4328 7 21.613 11.5898 21.613 11.5898L22 12L21.613 12.4102C21.613 12.4102 17.8019 16.5776 12.7332 16.9609C12.4913 16.9902 12.2495 17 12 17',
      key: 'x64btl',
    },
  ],
  [
    'path',
    {
      d: 'M12 7C6.5672 7 2.387 11.5898 2.387 11.5898L2 12L2.387 12.4102C2.387 12.4102 6.1981 16.5776 11.2668 16.9609C11.5087 16.9902 11.7505 17 12 17',
      key: '1wf96e',
    },
  ],
  [
    'path',
    {
      d: 'M12 7C9.1205 7 6.7862 9.2386 6.7862 12C6.7862 14.7614 9.1205 17 12 17',
      key: 'k4aw0g',
    },
  ],
  [
    'circle',
    {
      cx: '12',
      cy: '12',
      r: '1',
      key: '41hilf',
    },
  ],
]);
